import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function DropdownMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // logout function
    const navigate = useNavigate();
  
    const handleLogout = () => {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      navigate('/');
    };

  // Close the dropdown when clicking outside of it
   useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={menuRef} className="flex relative">
      <div className="flex relative inline-block text-left">
        <button
          onClick={() => setOpen(!open)}
          className="hover:text-green-700"
        >
          {/* Profile picture */}
          <div className="flex text-center rounded-full outline w-[2.5em] h-[2.5em] outline-1 outline-gray-400">
            <img
              src="/images/profile.png"
              alt="Profile"s
              className="flex justify-center items-center w-full h-full px-2 my-auto pt-1 pb-2"
            />
          </div>
        </button>

        {/* Dropdown always rendered */}
        <div
          className={`
            absolute right-0 top-[3.1em] w-48 bg-white border rounded-3xl shadow-xl
            transition-all duration-500 ease-in-out transform origin-top-right font-nunito font-light
            ${open ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'}
          `}
        >
          {/* No link for now */} <div className="flex block px-4 py-2 text-md rounded-t-3xl hover:bg-gray-100">
            <div className="flex ml-auto pr-4 gap-2">
              <span className="">min side</span>
              <img
                  src="/images/logo_black_outline.png"
                  alt="min side"
                  className="h-[1em] inline-block align-text-bottom relative top-[6px]"
              />
            </div>
          {/* No link for now */} </div>
          <a
            href="mailto:kontakt@matly.dk"
            className="flex block px-4 py-2 text-md hover:bg-gray-100"
          >
            <div className="flex ml-auto pr-4 gap-2 items-center">
              <span>feedback</span>
              <img src="/images/feedback.png" alt="mail" className="h-[0.9em]" />
            </div>
          </a>
          <button
            onClick={handleLogout}
            className="w-full flex block px-4 py-2 text-md text-right rounded-b-3xl hover:bg-gray-100"
          >
            <div className="flex ml-auto pr-4 gap-2">
              <span className="">log ud</span>
              <img
                  src="/images/logout.png"
                  alt="min side"
                  className="h-[0.9em] w-[0.9em] inline-block align-text-bottom relative top-[6px]"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}